// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Vujfn"};